import React from 'react';
import { ShieldCheck, Sparkles, Target, Heart, CheckCircle, ArrowRight } from 'lucide-react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { BUSINESS_INFO } from '../utils/constants';
import WhatsAppIcon from '../components/ui/WhatsAppIcon';

const About = () => {
  const values = [
    { icon: Target, title: 'Excellence', description: 'We strive for perfection in every detail, ensuring your vehicle looks its absolute best.' },
    { icon: Heart, title: 'Customer First', description: 'Your satisfaction is our priority. We go above and beyond to exceed expectations.' },
    { icon: ShieldCheck, title: 'Reliability', description: 'Punctual, professional, and consistent service you can depend on every time.' },
    { icon: Sparkles, title: 'Quality', description: 'Premium products and proven techniques for showroom-quality results.' },
  ];

  const whyChooseUs = [
    'Fully mobile service — we come to you',
    'Professional-grade products and equipment',
    'Trained and experienced technicians',
    'Flexible scheduling to fit your lifestyle',
    'Competitive and transparent pricing',
    'Eco-friendly cleaning solutions',
    'Full insurance coverage',
    'Satisfaction guaranteed',
  ];

  return (
    <div>
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <div className="eyebrow">About ARA</div>
            <h1>About ARA Mobile Valeting</h1>
            <p>Your trusted partner in professional mobile car care.</p>
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="about-grid">
            <div>
              <div className="eyebrow">Our Story</div>
              <h2>Bringing Premium Car Care to Your Doorstep</h2>
              <p>
                ARA Mobile Valeting was born from a simple idea: professional car care
                should be convenient, accessible, and exceptional. We recognized that
                busy professionals and families needed a better solution than
                traditional car washes.
              </p>
              <p>
                What started as a one-person operation has grown into a trusted team
                of experienced technicians serving Sheffield and surrounding areas.
                Our commitment to quality, reliability, and customer satisfaction has
                earned us hundreds of loyal customers and countless 5-star reviews.
              </p>
              <p>
                Today, we're proud to be one of the leading mobile valeting services
                in the region, combining cutting-edge techniques with time-tested
                methods to deliver results that consistently exceed expectations.
              </p>

              <div style={{ marginTop: '2rem' }}>
                <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
                  <Button variant="primary" icon={WhatsAppIcon}>
                    Book Your Service
                    <ArrowRight size={18} />
                  </Button>
                </a>
              </div>
            </div>

            <div className="grid grid-2 gap-lg">
              <Card hover className="stat-card">
                <div className="stat-number">1+</div>
                <div className="stat-label">Years Experience</div>
              </Card>
              <Card hover className="stat-card">
                <div className="stat-number">100+</div>
                <div className="stat-label">Vehicles Valeted</div>
              </Card>
              <Card hover className="stat-card">
                <div className="stat-number">100+</div>
                <div className="stat-label">Happy Clients</div>
              </Card>
              <Card hover className="stat-card">
                <div className="stat-number">4.9★</div>
                <div className="stat-label">Average Rating</div>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-black">
        <div className="container">
          <div className="section-header">
            <div className="eyebrow">Our Values</div>
            <h2>What Drives Us</h2>
            <p>
              Our core values guide everything we do, from how we treat our customers
              to the quality of service we deliver.
            </p>
          </div>

          <div className="grid grid-4">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <Card key={index} hover className="value-card">
                  <div className="value-icon">
                    <Icon size={32} />
                  </div>
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-description">{value.description}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="section-header">
            <div className="eyebrow">Why Choose Us</div>
            <h2>The ARA Difference</h2>
            <p>Here's what sets us apart from other car valeting services.</p>
          </div>

          <Card style={{ padding: '2rem', maxWidth: '1000px', margin: '0 auto' }}>
            <div className="checklist">
              {whyChooseUs.map((reason, index) => (
                <div key={index} className="checklist-item">
                  <CheckCircle size={20} />
                  <span>{reason}</span>
                </div>
              ))}
            </div>
          </Card>

          <div style={{ marginTop: '3rem' }}>
            <div className="cta-section">
              <h2>Ready to Experience the Difference?</h2>
              <p>
                Join hundreds of satisfied customers who trust us with their vehicles.
              </p>
              <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
                <Button variant="primary" size="lg" icon={WhatsAppIcon}>
                  Book Your Service Today
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;